import React from 'react';
import Spinner from '@/components/platform/ui/Spinner';

interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  loading?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'primary' | 'secondary' | 'danger';
  className?: string;
}

export default function PrimaryButton({
  children,
  onClick,
  type = 'button',
  disabled = false,
  loading = false,
  size = 'md',
  variant = 'primary',
  className = '',
}: PrimaryButtonProps) {
  const baseClasses =
    'font-semibold text-white shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2 touch-manipulation inline-flex items-center justify-center gap-2';

  const sizeClasses = {
    xs: 'rounded-md px-2 py-1.5 text-sm',
    sm: 'rounded-md px-2 py-1.5 text-sm',
    md: 'rounded-md px-3 py-2 text-sm',
    lg: 'rounded-md px-3 py-2 text-sm',
    xl: 'rounded-md px-3.5 py-2.5 text-sm',
  };

  const getVariantClasses = () => {
    return {
      primary: 'bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600',
      secondary: 'bg-gray-600 hover:bg-gray-500 focus-visible:outline-gray-600',
      danger: 'bg-red-600 hover:bg-red-500 focus-visible:outline-red-600',
    };
  };

  const variantClasses = getVariantClasses();

  const disabledClasses = 'disabled:opacity-50 disabled:cursor-not-allowed';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${disabledClasses} ${className}`}
    >
      {loading ? (
        <>
          <Spinner size="sm" darkMode={true} />
          <span>Loading...</span>
        </>
      ) : (
        children
      )}
    </button>
  );
}
